import React from "react";

const ChatBoxTextInput = () => (
    <div className="chatbox-text-input">
        <button className="chatbox-text-input__btn">+</button>
        <input className="chatbox-text-input__input" type="text" />
    </div>
);

export default ChatBoxTextInput;



// WEBPACK FOOTER //
// ./src/components/landingPage/ChatBoxTextInput.jsx